<template>
    <div class="level">
      <qd-collapse class="column is-5 is-paddingless" >
        <div class="columns is-multiline is-marginless subMenu">
          <div class="column is-12 is-paddingless">
            <div class="level-right">
              <button @click="close()" class="button is-subMenu">
                <b-icon icon="close"
                  custom-size="mdi-10px"
                  type="is-white">
                </b-icon>
              </button>
            </div>
            <display-menu-and-sub-menu :menuAndSubMenu="stockMenu">
            </display-menu-and-sub-menu>
          </div>
        </div>
      </qd-collapse>
    </div>
  </template>

<script>
import { createNamespacedHelpers } from 'vuex';
import displayMenuAndSubMenu from '@/components/sideBar/submenuSidebar/displayMenuAndSubMenu';
import { BON_STOCK } from '@/configuration/bonStock/permissionsStockConf';
import {
  LISTE_BON_ENTREE_ROUTE,
  LISTE_BON_SORTIE_ROUTE,
} from '@/configuration/bonStock/menuStockConf';
import { SET_STOCK_MENU } from '@/store/modules/menu/menu-mutation-type';

const menu = createNamespacedHelpers('menu');
const Parametres = createNamespacedHelpers('parametres');

export default {
  components: {
    displayMenuAndSubMenu,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    stockMenu() {
      return [
        {
          title: 'sidebar.bonStock.entreeMenu',
          path: LISTE_BON_ENTREE_ROUTE,
          noSubMenu: true,
          perm: BON_STOCK.lecture,
        },
        {
          title: 'sidebar.bonStock.sortieMenu',
          path: LISTE_BON_SORTIE_ROUTE,
          noSubMenu: true,
          perm: BON_STOCK.lecture,
        },
      ];
    },
  },
  methods: {
    ...menu.mapMutations({
      setStockMenu: SET_STOCK_MENU,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    close() {
      this.setStockMenu(false);
    },
  },
};
</script>
